import { useQuery } from 'react-query';

import auth from '@udacity/ureact-hoth';

import { getAnonymousIdCookie } from '~/features/cookies/utils/get-anonymous-id-cookie';
import { getCouponCodeFromCookie } from '~/features/discount/utils/get-coupon-code-from-cookie';
import { Currency } from '~/features/internationalization/models/currency';
import { getViewerCurrency } from '~/features/internationalization/utils/get-viewer-currency';

import { getStandaloneProgramPrice } from '../controllers/get-standalone-program-price';

export function useStandaloneProgramPrice({
  currency = getViewerCurrency(),
  nodeKey,
  learningPlanKey,
}: {
  currency?: Currency;
  nodeKey?: string;
  learningPlanKey?: string;
}) {
  const coupon = getCouponCodeFromCookie();

  return useQuery(
    ['standalone-pricing', currency, nodeKey, learningPlanKey, coupon ?? null],
    () => {
      const anonymousId = getAnonymousIdCookie();
      const userId = auth.getCurrentUserId();
      if (nodeKey) {
        return getStandaloneProgramPrice({ currency, nodeKey, coupon, anonymousId, userId });
      } else if (learningPlanKey) {
        return getStandaloneProgramPrice({ currency, learningPlanKey, coupon, anonymousId, userId });
      }
    },
    {
      enabled: Boolean(currency) && (Boolean(nodeKey) || Boolean(learningPlanKey)),
    }
  );
}
